import React, { useCallback } from 'react';
import { RootState } from 'app/rootReducer';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { saveAs } from '@progress/kendo-file-saver';
import logo from '../../app/logo.jpg';


export default function ShowPreview(){
    let house = useSelector(
        (state: RootState) => state.house
    )
    let extra = useSelector(
        (state: RootState) => state.extraSlice
    )
    const history = useHistory();
    const Callback = useCallback((val) => history.push(val), [history]);

    function saveFile(){
        let finalFile: string
        let fileName = house.houseName.replaceAll(' ','_');
        let infoFile = finalFileGenerate();
        let etsFile = etsGenerate();
        let yamlFile = writeYaml();
        let combinedJSON = {...house, ...extra}
        finalFile = JSON.stringify(combinedJSON, null, 1);
        console.log(finalFile)
        let blob = new Blob([finalFile], {type: 'application/json;charset=utf-8'})
        saveAs(blob, `${fileName}_variables.json`)

        let infoBlob = new Blob([infoFile], {type: 'text/csv;charset=utf-8'})
        saveAs(infoBlob, `${fileName}_information.csv`)

        let etsBlob = new Blob([etsFile], {type: 'text/csv;charset=utf-8'});
        saveAs(etsBlob,`${fileName}_ets.csv`)

        let yamlBlob = new Blob([yamlFile], {type: 'text/yaml;charset= utf-8'})
        saveAs(yamlBlob,`${fileName}_homeAssistant.yaml`)
    }

    // Generates the information .csv file. The chara
    function finalFileGenerate(){
        // The final string that will be used to create the csv file
        let string = "";
        // Header rows for the top of the csv file
        const header = house.el_install 
            ? ['Etasje','Rom','Funksjon','Navn','Lyselementer','Dali','Dim','Rele','M^2', 'Multimedia/audiovisuelle enheter', 'Enkle uttak', 'Dobble uttak', '4 veis uttak', 'Totalt antall uttak', 'Kjøkkenbenk', 'Fri vegg', 'Faste elektrisk utstyr', 'Spiseplass']
            : ['Etasje','Rom','Funksjon','Navn','Lyselementer','Dali','Dim','Rele'];
        // Adds the header to the file
        string += header.join(";") + '\r\n'

        // Loop through all the rooms in the house and write all the values for rgb, light, heat, cooling and sun. 
        // If user has selected El installation then add that information as well
        house.rooms.map((room) => {
            let name: string = room.Navn;
            name.replace("ø", "o");
            name.replace("å", "a");
            name.replace("æ", "e");
            room["rgb"]["values"].map((val: any) => {
                let rgbArr = [room.Etasje, name, 'RGB', val];
                string += rgbArr.join(";") + '\r\n'
            })

            room["light"]["values"].map((val: any) => {
                let lightArr = [room.Etasje, name, 'Lyssone', val.navn, val.elements, val.type.dali ? 'Ja' : '', val.type.dim ? 'Ja' : '', val.type.rele ? 'Ja' : ''];
                string += lightArr.join(";") + '\r\n'
            })

            room["heat"]["values"].map((val: any) => {
                let heatArr = [room.Etasje, name, 'Varmesone', val];
                string += heatArr.join(";") + '\r\n'
            })

            room["cooling"]["values"].map((val: any) => {
                let coolArr = [room.Etasje, name, 'Kjoling', val];
                string += coolArr.join(";") + '\r\n'
            })

            room["sun"]["values"].map((val: any) => {
                let sunArr = [room.Etasje, name, 'Solavskjerming', val];
                string += sunArr.join(";") + '\r\n'
            })

            if(house.el_install){
                let elArr = [room.Etasje, name, "El-Installasjon", room["elInstall"].roomName,'','','','',room["elInstall"].roomSize,room["elInstall"].audio ? 'Ja' : 'Nei',room["elInstall"].singleStick,room["elInstall"].doubleStick,room["elInstall"].fourwayStick, room["elInstall"].totalAmount,room["elInstall"].benchSize,room["elInstall"].wallSize,room["elInstall"].equipmentAmount,room["elInstall"].eatingArea ? 'Ja' : 'Nei']
                string += elArr.join(";") + '\r\n';
            }
        })
        string += '\r\n'

        // Maps through all the extra functions and writes their values to the csv file
        Object.keys(extra).map((val: any) => {
            let extraArr: any[];
            if (val === "accesspoints"){
                if (extra[val]["selected"]){
                    extraArr = new Array();
                    extraArr.push(["","","Ekstra Funksjon","Aksesspunkt", `${parseInt(extra[val]["amount_access"])} aksesspunkt`])
                    extra[val]["data_val"].map((v: any, i: any) => {
                        extraArr.push(["","","Ekstra Funksjon","", "Datapunkt", v])
                    }
                    )
                    extraArr.map((v) => {
                        string += v.join(";") + '\r\n'
                    })
                }
                
                
            }
            if (val ==="macros") {
                if (!extra[val]["selected"]) return null;
                extraArr = new Array()
                extra[val]["values"].map((list: any) => {
                    extraArr.push(["","","Ekstra Funksjon","Macro/Scene", list]);
                    
                })
                extraArr.map((v) => {
                    string += v.join(";") + '\r\n'
                })
            }
            if(val ==="name") return null
            if (extra[val]) {
                extraArr = ["","","Ekstra Funksjon",extra["name"][val]];
                string += extraArr.join(";") + '\r\n'
            }
        })

        return string
    }

    function writeYaml(){
        let tab = '\t\t\t'
        let a_light = 0;
        let a_heat = 0;
        let a_sun = 0;
        let a_rgb = 0;
        let a_cool = 0;
        let txt_light = ""
        let txt_heat = "";
        let txt_sun = "";
        let txt_rgb = "";
        let txt_cool_bin = "";
        let txt_cool_sensor = "";
        let txt_weather = "";
        txt_weather += `- name: "Verstasjon" \n${tab}address_temperature: "0/2/0"\n${tab}address_brightness_south: "0/2/6" \n${tab}address_brightness_west: "0/2/7" \n${tab}address_brightness_east: "0/2/8" \n${tab}address_brightness_north: "0/2/9" \n${tab}address_wind_speed: "0/2/2" \n${tab}address_day_night: "0/2/14"`;
        
        let string = "knx:\n\t";
        

        house.rooms.map((v) => {
            v.light.values.map((l: any) => {
                txt_light += `- name: "${v.Navn} - ${l.navn}"\n${tab}address: "1/1/${a_light}"\n${tab}state_address: "1/2/${a_light}"\n${tab}brightness_address: "1/4/${a_light}"\n${tab}brightness_state_address: "1/5/${a_light}"\n\t\t`
                a_light++;
            })

            v.heat.values.map((i: any) => {
                txt_heat += `- name: "${v.Navn} - ${i}" \n${tab}temperature_address: "2/0/${a_heat}" \n${tab}target_temperature_address: "2/1/${a_heat}" \n${tab}target_temperature_state_address: "2/2/${a_heat}" \n${tab}operation_mode_address: "2/6/${a_heat}" \n\t\t`
                a_heat++;
            })
            
            v.sun.values.map((k: any) => {
                txt_sun += `- name: "${v.Navn} - ${k}"\n${tab}position_address: "3/0/${a_sun}"\n${tab}position_state_address: "3/1/${a_sun}" \n${tab}move_short_address: "3/2/${a_sun}" \n${tab}move_long_address: "3/3/${a_sun}" \n${tab}stop_address: "3/4/${a_sun}" \n\t\t`
                a_sun++;
            })

            v.rgb.values.map((j: any) => {
                txt_rgb += `- name: "${v.Navn} - ${j}" \n${tab}address: "4/0/${a_rgb}" \n${tab}state_address: "4/1/${a_rgb}" \n${tab}brightness_address: "4/2/${a_rgb}" \n${tab}brightness_state_address: "4/3/${a_rgb}" \n${tab}color_address: "4/4/${a_rgb}" \n${tab}color_state_address: "4/5/${a_rgb}" \n\t\t`
                a_rgb++;
            })
            v.cooling.values.map((o:any) => {
                txt_cool_bin += `- name: "${v.Navn} - ${o} Av_paa" \n${tab}state_address: "5/0/${a_cool}"\n\t\t`
                txt_cool_sensor += `- name: "${v.Navn} - ${o} - Kjolepaadrag" \n${tab}state_address: "5/0/${a_cool + 1}" \n${tab}type: percent \n\t\t- name: "${v.Navn} - ${o} - Kjolepaadrag status" \n${tab}state_address: "5/1/${a_cool + 1}" \n${tab}type: percent \n\t\t- name: "${v.Navn} - ${o} - Viftepaadrag" \n${tab}state_address: "5/2/${a_cool + 1}" \n${tab}type: percent \n\t\t- name: "${v.Navn} - ${o} - Viftepaadrag status" \n${tab}state_address: "5/3/${a_cool + 1}" \n${tab}type: percent \n\t\t`
                a_cool += 2;
            })
        })

        string += `light:\n\t\t${txt_light}${txt_rgb}\n\tclimate:\n\t\t${txt_heat}\n\tcover:\n\t\t${txt_sun}\n\tbinary_sensor:\n\t\t${txt_cool_bin}\n\tsensor:\n\t\t${txt_cool_sensor}\n\tweather:\n\t\t${txt_weather}`
        return string
    }

    function etsGenerate(){
        const ets = '"Main","Middle","Sub","Main","Middle","Sub","Central","Unfiltered","Description","DatapointType","Security"\r\n';
        let string = ""
        // Main group address
        let group_adress = 0
        // The base components for the light ets groups
        const light_base = new Array(['Lys', '', '', '1', '', '','','','','','Auto'], ['','Sentralfunksjoner lys Room', '', '1', '0', '','','','','','Auto'], ['','Bryter','','1','1','','','','','','Auto'], ['','Bryter status','','1','2','','','','','','Auto'],
        ['','Relativ dimming','','1','3','','','','','','Auto'],['','Lys verdi','','1','4','','','','','','Auto'],['','Lys verdi status','','1','5','','','','','','Auto'],['','Feil og statuser','','1','6','','','','','','Auto'],['','Master/slave input','','1','7','','','','','','Auto']
        );

        // The base components for the heat ets groups
        const heat_base = new Array(['Varme ', '', '', '2', '',''],['','Er-Verdi T_PV','','2','0',''],['','Set Temp T_SP','','2','1',''],['','Onsket Temp T_SCP','','2','2',''],['','Varmepaadrag V_OP','','2','3',''],
        ['','Feil varmeventil','','2','4',''],['','Status varmepaadrag','','2','5',''],['','HVAC','','2','6',''],['','Feil tempfoler T_AL','','2','7','']);

        const sun_base = new Array(['Solavskjerming','','','3','',''],['','Posisjon','','3','0',''],['','Posisjon Status','','3','1',''],['','Move kort','','3','2',''],['','Move lang','','3','3',''],
        ['','Stop','','3','4','']);

        const rgb_base = new Array(['RGB','','','4','',''],['','Bryter','','4','0',''],['','Bryter Status','','4','1',''],['','Lys verdi','','4','2',''],['','Lys verdi status','','4','3',''],
        ['','Farge','','4','4',''],['','Farge Status','','4','0','']);

        const cool_base = new Array(['Avkjoling','','','5','',''],['','Kjolepaadrag','','5','0',''],['','Kjolepaadrag status','','5','1',''],['','Viftepaadrag','','5','2',''],
        ['','Viftepaadrag status','','5','3','']);

        // Standard comp ISE-REMOTE parts for ETS group address
        const ise_remote = new Array(['','ISE REMOTE','',group_adress,'5','','','','','','Auto'],['','',"Tildel fjerntilgang",group_adress,"5","0","","","Sikringskap VPN ISE","DPST-1-3","Auto"],['','',"Tildel fjerntilgang status",group_adress,"5","1","","","Sikringskap VPN ISE","DPST-1-3","Auto"],['','',"Tildel Beboernes fjerntilgang",group_adress,"5","2","","","Sikringskap VPN ISE","DPST-1-3","Auto"],
        ['','',"Tildel Beboernes fjerntilgang status",group_adress,"5","3","","","Sikringskap VPN ISE","DPST-1-3","Auto"],['','',"Tildel Instalator fjerntilgang",group_adress,"5","4","","","Sikringskap VPN ISE","DPST-1-3","Auto"],['','',"Tildel installors fjerntilgang status",group_adress,"5","5","","","Sikringskap VPN ISE","DPST-1-3","Auto"],
        ['','',"Tillat kjapp forbindelsestilgang",group_adress,"5","6","","","Sikringskap VPN ISE","DPST-1-3","Auto"],['','',"Tillat Kjapp forbindelse fjerntilgang status",group_adress,"5","7","","","Sikringskap VPN ISE","DPST-1-3","Auto"],['','',"stat portal forbindelse",group_adress,"5","8","","","Sikringskap VPN ISE","DPST-1-11","Auto"],
        ['','',"Tilstand enhver fjernforbindelse",group_adress,"5","9","","","Sikringskap VPN ISE","DPST-1-11","Auto"],['','',"Tilstand fjernforbindelse beboere",group_adress,"5","10","","","Sikringskap VPN ISE","DPST-1-11","Auto"],['','',"Tilstand fjernforbindelse installatorere",group_adress,"5","11","","","Sikringskap VPN ISE","DPST-1-11","Auto"],
        ['','',"Tilstand fjernforbindelse kjapp forbindelse",group_adress,"5","12","","","Sikringskap VPN ISE","DPST-1-11","Auto"],['','',"Feilmelding indikasjon",group_adress,"5","13","","","Sikringskap VPN ISE","DPST-1-5","Auto"],['','',"Portal forbindelse",group_adress,"5","14","","","Sikringskap VPN ISE","DPST-16-1","Auto"],['','',"Info feilmelding forbindelse",group_adress,"5","15","","","Sikringskap VPN ISE","DPST-16-1","Auto"]
        );

        // Standard comp Z41 parts for ETS group address
        const skjerm = new Array(['','Skjerm','',group_adress,'0','','','','','Auto'],['','','Foresporsel tid',group_adress,'0','1','true','','','DPT-1','Auto'], ['','','Dato felles',group_adress,'0','2','','','','DPST-11-1', 'Auto'],['','','Klokke felles',group_adress,'0','3','','','','DPST-10-1','Auto'],
        ['','','Dato og tid',group_adress,'0','4','','','','DPST-19-1','Auto'], ['','','Utloser send dato/tid',group_adress,'0','5','','','','DPST-1-17','Auto'], ['','','NTP status foresporsel status',group_adress,'0','6','','','','DPST-1-2','Auto'],
        ['','','RF Batteri Status',group_adress,'0','7','','','','','Auto']);

        // Standard comp Værstasjon ETS group address
        const stasjon = new Array(['','Vaerstasjon','',group_adress,'2','','','','','','Auto'],['','','Utetemp',group_adress,'2','0','true','','','DPST-9-1','Auto'], ['','','Lysstyrke sensor 1',group_adress,'2','1','','','','','Auto'],['','','Vind sensor',group_adress,'2','2','','','','','Auto'],
        ['','','Overvaakning null vind signal',group_adress,'2','3','','','','','Auto'],['','','Overvaakning uendret vind sensor',group_adress,'2','4','','','','','Auto'],['','','Overvaakning varmme spenning ok',group_adress,'2','5','','','','','Auto'],
        ['','','Lux sensor kanal sor',group_adress,'2','6','','','','','Auto'],['','','Lux sensor kanal vest',group_adress,'2','7','','','','','Auto'], ['','','Lux sensor kanal ost',group_adress,'2','8','','','','','Auto'], 
        ['','','Lux sensor kanal nord',group_adress,'2','9','','','','','Auto'], ['','','Lux sensor kanal 5',group_adress,'2','10','','','','','Auto'], ['','','Lux sensor kanal 6',group_adress,'2','11','','','','','Auto'],
        ['','','Lux Sensor Master',group_adress,'2','12','','','','','Auto'], ['','','Lux Sensor Slave',group_adress,'2','13','','','','','Auto'], ["","","Utelys dag natt",group_adress,"2","14","","","","","Auto"]
        );
        // The Arrays holding the information
        let central_map = new Array();
        let light_map = new Array();
        let heat_map = new Array();
        let sun_map = new Array();
        let rgb_map = new Array();
        let cool_map = new Array();
        // The sub groupnumber that will be applied
        let a_light = 0;
        let a_heat = 0;
        let a_sun = 0;
        let a_rgb = 0;
        let a_cool = 0;

        central_map.push(['Sentralfunksjoner','','',group_adress,'','','','','','','Auto'])
        if(extra["ISE"]){
            ise_remote.map((v) => {
                central_map.push(v);
            })
        }
        if(extra["Z41"]){
            skjerm.map((v) => {
                central_map.push(v);
            })
        }
        if(extra["weather"]){
            stasjon.map((v) => {
                central_map.push(v);
            })
        }
        if(extra["macros"]["selected"]){
            central_map.push(['','Macro/Scene','',group_adress,'3','','','','','','Auto'])
            extra["macros"]["values"].map((v: any,i: any) => {
                central_map.push(['','',v, group_adress,'3',i,'','','','','Auto'])
            })
        }

        // Increases the group address as we have move on
        group_adress++;

        light_base.map((v) => {
            light_map.push(v);
        });

        group_adress ++;

        heat_base.map((v) => {
            heat_map.push(v);
        });

        rgb_base.map((v) => {
        rgb_map.push(v);
        })

        cool_base.map((v) => {
            cool_map.push(v)
        })

        sun_base.map((v) => {
            sun_map.push(v)
        })

        house.rooms.map((v) => {
            group_adress = 1
            v.light.values.map((l: any) => {
                light_map.push(['','','Bryter - ' + v.Navn + ' - ' + l.navn, group_adress, '1', a_light,'','','','DPST-1-1','Auto'])
                light_map.push(['','','Bryter Status - ' + v.Navn + ' - ' + l.navn, group_adress, '2', a_light,'','','','DPST-1-1','Auto'])
                light_map.push(['','','R.dim - ' + v.Navn + ' - Lyssone: ' + l.navn, group_adress, '3', a_light,'','','','DPST-3-7','Auto'])
                light_map.push(['','','Lys verdi - ' + v.Navn + ' - ' + l.navn, group_adress, '4', a_light,'','','','DPST-5-1','Auto'])
                light_map.push(['','','Lys verdi status - ' + v.Navn + ' - ' + l.navn, group_adress, '5', a_light,'','','','DPST-5-1','Auto'])
                light_map.push(['','','Feil - ' + v.Navn + ' - ' + l.navn, group_adress, '6', a_light,'','','','DPST-1-1','Auto'])
                light_map.push(['','','Detektor master inngang - ' + v.Navn + ' - ' + l.navn, group_adress, '7', a_light,'','','','DPST-1-1','Auto'])
                a_light++;
            })
            group_adress ++;

            v.heat.values.map((i: any) => {
                heat_map.push(['','','Er-Verdi - ' + v.Navn + ' - ' + i, group_adress,'0', a_heat,'','','','DPST-9-1','Auto'])
                heat_map.push(['','','Set Temp - ' + v.Navn + ' - ' + i, group_adress,'1', a_heat,'','','','DPST-9-1','Auto'])
                heat_map.push(['','','Onsket Temp - ' + v.Navn + ' - ' + i, group_adress,'2', a_heat,'','','','DPST-9-1','Auto'])
                heat_map.push(['','','Varmepaadrag - ' + v.Navn + ' - ' + i, group_adress,'3', a_heat,'','','','','Auto'])
                heat_map.push(['','','Feil varmeventil - ' + v.Navn + ' - ' + i, group_adress,'4', a_heat,'','','','DPT-7','Auto'])
                heat_map.push(['','','Status varmepaadrag - ' + v.Navn + ' - ' + i, group_adress,'5', a_heat,'','','','DPT-5','Auto'])
                heat_map.push(['','','Varmemodus - ' + v.Navn + ' - ' + i, group_adress,'6', a_heat,'','','','DPST-20-102','Auto'])
                heat_map.push(['','','Feil - ' + v.Navn + ' - ' + i, group_adress,'7', a_heat,'','','','DPST-1-5','Auto'])
                a_heat++;
            })
            group_adress ++;
            
            v.sun.values.map((k: any) => {
                sun_map.push(['','',`Posisjon - ${v.Navn} - ${k}`, group_adress, '0', a_sun, '','','','','Auto'])
                sun_map.push(['','',`Posisjon Status - ${v.Navn} - ${k}`, group_adress, '1', a_sun, '','','','','Auto'])
                sun_map.push(['','',`Move kort - ${v.Navn} - ${k}`, group_adress, '2', a_sun, '','','','','Auto'])
                sun_map.push(['','',`Move lang - ${v.Navn} - ${k}`, group_adress, '3', a_sun, '','','','','Auto'])
                sun_map.push(['','',`Stop - ${v.Navn} - ${k}`, group_adress, '4', a_sun, '','','','','Auto'])
                a_sun++;
            })

            group_adress ++;

            v.rgb.values.map((j: any) => {
                rgb_map.push(['','',`Bryter - ${v.Navn} - ${j}`, group_adress, '0',a_rgb,'','','','','Auto']);
                rgb_map.push(['','',`Bryter Status - ${v.Navn} - ${j}`, group_adress, '1',a_rgb,'','','','','Auto']);
                rgb_map.push(['','',`Lys verdi - ${v.Navn} - ${j}`, group_adress, '2',a_rgb,'','','','','Auto']);
                rgb_map.push(['','',`Lys verdi status - ${v.Navn} - ${j}`, group_adress, '3',a_rgb,'','','','','Auto']);
                rgb_map.push(['','',`Farge - ${v.Navn} - ${j}`, group_adress, '4',a_rgb,'','','','','Auto']);
                rgb_map.push(['','',`Farge Status - ${v.Navn} - ${j}`, group_adress, '5',a_rgb,'','','','','Auto']);
                a_rgb++;
            })
            group_adress ++;

            v.cooling.values.map((o:any) => {
                cool_map.push(['','',`Bit start/stop - ${v.Navn} - ${o}`, group_adress, '0', a_cool,'','','','','Auto'])
                cool_map.push(['','',`--------------`, group_adress, '1', a_cool,'','','','','Auto'])
                cool_map.push(['','',`--------------`, group_adress, '2', a_cool,'','','','','Auto'])
                cool_map.push(['','',`--------------`, group_adress, '3', a_cool,'','','','','Auto'])
                cool_map.push(['','',`Kjolepaadrag - ${v.Navn} - ${o}`, group_adress, '0', a_cool + 1,'','','','','Auto'])
                cool_map.push(['','',`Kjolepaadrag status - ${v.Navn} - ${o}`, group_adress, '1', a_cool + 1,'','','','','Auto'])
                cool_map.push(['','',`Viftepaadrag - ${v.Navn} - ${o}`, group_adress, '2', a_cool + 1,'','','','','Auto'])
                cool_map.push(['','',`Viftepaadrag status - ${v.Navn} - ${o}`, group_adress, '3', a_cool + 1,'','','','','Auto'])
                a_cool += 2;
            })
        })

        string += ets;
        central_map.map((v) => {
            string += v.join(";") + "\r\n"
        });
        light_map.map((v) => {
            string += v.join(";") + "\r\n"
        });
        heat_map.map((v) => {
            string += v.join(";") + "\r\n"
        });
        
        sun_map.map((v) => {
        string += v.join(";") + '\r\n'
        });

        rgb_map.map((v) => {
            string += v.join(";") + '\r\n'
        });

        cool_map.map((v) => {
            string += v.join(";") + '\r\n'
        });

        return string
    }

    // The function that handles routing to the different pages
    function HandleSubmit(destination: string){
        console.log(extra)
        switch (destination) {
            case "tilbake":
                Callback("/extra/")
                break;
            case "home":
                Callback("/");
                break;
            default:
                break;
        }
    }

    // Returns the preview list
    return (
        <div>
            <div>
                <img src={logo} />
            </div>
            <div className="mainDiv">
                <p className="highlightText">Navn: {house.houseName}</p>
                <p className="highlightText">Antall Rom: {house.roomAmount}</p>
                <p className="highlightText">Antall Etasjer: {house.floorAmount}</p>
                <hr />
                {house.rooms.map((room, i) => (
                    <div>
                        <h3>{room.Navn} - Etasje {room.Etasje}</h3>
                        <h4>RGB:</h4>
                        <ul>
                            {room["rgb"]["values"].map((list: any) => (
                                <li>{list}</li>
                            ))}
                        </ul>
                        <hr />
                        <h4>Lys:</h4>
                        <ul>
                            {room["light"]["values"].map((list: any) => (
                                <li>{list["navn"]} - {parseInt(list["elements"])} elementer av typen {Object.keys(list["type"]).filter((val) => {
                                    console.log(list["type"][val])
                                    if (list["type"][val] === true) return val
                                })}</li>
                            ))}
                        </ul>
                        <hr />
                        <h4>Varmesoner</h4>
                        <ul>
                            {room["heat"]["values"].map((list: any) => (
                                <li>{list}</li>
                            ))}
                        </ul>
                        <hr />
                        <h4>Avkjoling</h4>
                        <ul>
                            {room["cooling"]["values"].map((list: any) => (
                                <li>{list}</li>
                            ))}
                        </ul>
                        <hr />
                        <h4>Solavskjerming</h4>
                        <ul>
                            {room["sun"]["values"].map((list: any) => (
                                <li>{list}</li>
                            ))}
                        </ul>
                        <hr />
                        {house.el_install ? 
                        <div>
                            <h4>El-Installasjon</h4>
                            <ul>
                                <li>{room["elInstall"]["roomName"]}</li>
                                {room["elInstall"]["roomType"] === 4 
                                    ? <div>
                                        <li>{`Antall meter kjøkkenbenk: ${room["elInstall"]["benchSize"]}`}</li>
                                        <li>{`Antall meter fri vegg: ${room["elInstall"]["wallSize"]}`}</li>
                                        <li>{`Antall kjøkkenutstyr: ${room["elInstall"]["equipmentAmount"]}`}</li>
                                    </div>
                                    : <li>{`Størrelse på rommet: ${room["elInstall"]["roomSize"]}m^2`}</li>
                                }
                                <li>{`Antall enkelt stikker: ${room["elInstall"]["singleStick"]}`}</li>
                                <li>{`Antall doble stikker: ${room["elInstall"]["doubleStick"]}`}</li>
                                <li>{`Antall 4-veis stikker: ${room["elInstall"]["fourWayStick"]}`}</li>
                            </ul>
                            <hr />
                        </div>
                        : ""}
                    </div>
                ))}
                <div>
                    <h3>Ekstra funksjoner valgt:</h3>
                    <ul>
                        {Object.keys(extra).map((val: any) => {
                            if (val === "accesspoints"){
                                if (!extra[val]["selected"]) return null
                                return  (
                                    <div>
                                        <li>Aksesspunkt med {parseInt(extra[val]["amount_access"])} aksesspunkter</li>
                                        <ul>
                                            {extra[val]["data_val"].map((v: any, i: any) => (
                                                <li>Datapunkt: {v}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )
                            }
                            if (val ==="macros") {
                                if (!extra[val]["selected"]) return null;
                                console.log(extra[val]["values"])
                                {return extra[val]["values"].map((list: any) => (
                                    <li>Macro/Scene - {list}</li>
                                ))}
                            }
                            if(val ==="name") return null
                            if (extra[val]) return <li>{extra["name"][val]}</li>
                        })}
                    </ul>
                    <hr />
                </div>
                <button className="btnTilbake" onClick={() => HandleSubmit("tilbake")}>Tilbake</button>
                <button className="btnContinue" onClick={() => HandleSubmit("home")}>Forside</button>
                <button className="btnSave" onClick={() => saveFile()}>Lagre</button>
                
            </div>
            
        </div>
    )
}